import React, { useCallback, useState } from "react";
import {
  Upload,
  message,
  Form,
  Input,
  Button,
  Modal,
  Select,
  Spin,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
const { Option } = Select;
const AddDocumentation = ({
  setShowDocument,
  showDocument,

  onAddDocument,
  updateDocumentRes,

  onGetClientProfile,
  clientProfile,
  familyMemberDetail,
  onGetDocumentData,
  onAddMultiDocument,
}) => {
  const { t } = useTranslation();
  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const onFinish = async (values) => {
    if (!fileData.length) {
      message.error("Please select a file!");
      return;
    }
    const { familyId } = JSON.parse(localStorage.getItem("userDetail"));
    const selectedClient = JSON.parse(values.subjectId);
    setLoading(true);

    const formFileData = new FormData();
    for (let i = 0; i < fileData.length; i++) {
      formFileData.append("files", fileData[i]);
    }
    formFileData.append("BranchId", clientProfile && clientProfile.branchId);

    let uploadRes;
    try {
      uploadRes = await onAddMultiDocument(formFileData);
    } catch (err) {
      setLoading(false);
      return;
    }

    const uploadedFiles = (uploadRes && uploadRes.payload) || [];
    if (!uploadedFiles.length) {
      setLoading(false);
      message.error("File upload failed!");
      return;
    }

    const filesArr = uploadedFiles.map((p) => ({
      fileName: p.fileName,
      fileUrl: p.httpUrl,
      blobFileName: p.fileUrl,
      size: 0,
    }));

    const firstFile = fileData[0];
    const dataObj = {
      SubjectId: selectedClient.id,
      FamilyId: familyId,
      DocumentTypeId: parseInt("0"),
      Title: firstFile.name,
      SizeInKB: firstFile.size,
      DocuementExtension: firstFile && firstFile.type,
      IsAgent: false,
      IsClient: true,
      ShowAgent: false,
      ShowClient: true,
      QuestionnaireId: 0,
    };

    const data = {
      data: JSON.stringify(dataObj),
      files: {
        file: filesArr,
        itemId: 0,
      },
    };

    const res = await onAddDocument(data);
    if (res) {
      onGetDocumentData();
      handleCancel();
      setLoading(false);
      message.success("Document uploaded successfully!");
    } else {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    setShowDocument(false);
  };
  const onHandleChange = (e) => {
    setFileData(e.fileList.map((f) => f.originFileObj || f));
  };
  return (
    <div className="add-document">
      <Modal
        className="reminder-model-main"
        title={"ADD DOCUMENT"}
        visible={showDocument}
        onCancel={handleCancel}
        footer={false}
      >
        <Spin size="small" spinning={loading}>
          <Form
            name="document"
            onFinish={onFinish}
            scrollToFirstError
            form={form}
          >
            <Form.Item
              name={"subjectId"}
              label={t("Select User")}
              rules={[{ required: true, message: "Please select user!" }]}
            >
              <Select
                showSearch
                // mode="multiple"
                allowClear
                placeholder="Please Select"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                // onSelect={onSelectEmployer}
                // value={
                //   historyData &&
                //   historyData.employerId !==
                //     "00000000-0000-0000-0000-000000000000"
                //     ? historyData.employerName
                //     : null
                // }
                // disabled={
                //   historyData &&
                //   historyData.employerId ===
                //     "00000000-0000-0000-0000-000000000000"
                //     ? false
                //     : true
                // }
                // onClear={() =>
                //   this.setState({ selectedCategory: {} })
                // }
              >
                {familyMemberDetail &&
                  familyMemberDetail.items
                    .filter((el) =>
                      clientProfile?.clientPermission?.familyDocuments
                        ? true
                        : el.memberType === "Client"
                    )
                    .map((el) => (
                      <Option key={el.id || el._id} value={JSON.stringify(el)}>
                        {el.firstName} {el.lastName}
                      </Option>
                    ))}
              </Select>
            </Form.Item>
            <Form.Item>
              <Upload
                beforeUpload={(file, fileList) => {
                  if (fileData.length + fileList.length > 10) {
                    if (file.uid === fileList[0].uid) {
                      message.error(
                        "You can upload a maximum of 10 documents."
                      );
                    }
                    return Upload.LIST_IGNORE;
                  }
                  return false;
                }}
                onChange={onHandleChange}
                multiple={true}
              >
                <Button icon={<UploadOutlined />}></Button>
              </Upload>
            </Form.Item>
            <div className="mar-top d-flex submit-access-btn">
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button mr-24"
              >
                {t("Submit")}
              </Button>
            </div>
          </Form>
        </Spin>
      </Modal>
    </div>
  );
};

export default AddDocumentation;
